import React from 'react';
import Carousel from './Carousel';
import { AutoPlayCarouselProps } from 'types/sharedComponents';
import { useAutoplayPlugin } from 'hooks/useAutoplayPlugin';

const AutoPlayCarousel = ({ plugins, playOnInit, delay, ...props }: AutoPlayCarouselProps) => {
  const autoplayPlugin = useAutoplayPlugin({ playOnInit, delay });
  const allPlugins = [...(autoplayPlugin ? [autoplayPlugin] : []), ...(plugins ?? [])];

  return <Carousel plugins={allPlugins} {...props} />;
};

export default AutoPlayCarousel;
